import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SendIcon from '@material-ui/icons/Send';

export class DashboardDocuments extends Component {


    documentList() {
        const { documents } = this.props;
        return documents.map((document, i) => {
            return (
                <ListItem key={i}>
                    <ListItemIcon>
                        <SendIcon />
                    </ListItemIcon>
                    <ListItemText primary={document} />
                </ListItem>
            )

        })

    }



    render() {
        const { title } = this.props;
        return (
            <Card>
                <CardHeader title={title} className='romis-card-header' />
                <CardContent>
                    <List>

                        <li>
                            <ul>
                                {this.documentList()}


                            </ul>
                        </li>

                    </List>
                </CardContent>
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/DashboardDocuments.js